export const categories = [
  {
    id: 'tutorials',
    name: '动画制作教程',
    slug: 'tutorials',
    description: '从零基础到进阶技巧，系统学习同人动画制作的每一个环节。',
    icon: 'ri-movie-line',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20animation%20workspace%20with%20drawing%20tablet%20storyboard%20sketches%20pencils%20scattered%20on%20wooden%20desk%20soft%20natural%20lighting%20creative%20studio%20atmosphere%20artistic%20illustration%20vibe%20with%20cream%20and%20warm%20beige%20tones%20professional%20yet%20homely%20feel%20clean%20composition&width=800&height=600&seq=cat-tutorials-01&orientation=landscape'
  },
  {
    id: 'software',
    name: '软件推荐',
    slug: 'software',
    description: '精选最适合同人动画创作的专业软件，详细对比与使用指南。',
    icon: 'ri-computer-line',
    image: 'https://readdy.ai/api/search-image?query=Digital%20art%20tablet%20displaying%20animation%20timeline%20interface%20on%20minimalist%20desk%20setup%20warm%20ambient%20lighting%20modern%20creative%20studio%20soft%20beige%20and%20cream%20background%20clean%20aesthetic%20professional%20workspace%20elegant%20composition%20with%20natural%20textures&width=800&height=600&seq=cat-software-02&orientation=landscape'
  },
  {
    id: 'platforms',
    name: '投稿平台',
    slug: 'platforms',
    description: '国内外主流动画投稿平台全攻略，让你的作品被更多人看到。',
    icon: 'ri-upload-cloud-line',
    image: 'https://readdy.ai/api/search-image?query=Creative%20social%20media%20sharing%20concept%20with%20floating%20animation%20frames%20and%20play%20buttons%20warm%20atmospheric%20lighting%20soft%20cream%20and%20amber%20color%20palette%20artistic%20digital%20illustration%20style%20modern%20minimalist%20composition%20with%20subtle%20gradients&width=800&height=600&seq=cat-platforms-03&orientation=landscape'
  },
  {
    id: 'tips',
    name: '创作心得',
    slug: 'tips',
    description: '资深同人创作者的实战经验与心得分享，助你少走弯路。',
    icon: 'ri-lightbulb-line',
    image: 'https://readdy.ai/api/search-image?query=Creative%20brainstorming%20space%20with%20mood%20board%20sketches%20color%20swatches%20and%20inspiration%20notes%20pinned%20on%20cork%20board%20warm%20cozy%20lighting%20artistic%20studio%20vibe%20soft%20cream%20and%20terracotta%20tones%20clean%20aesthetic%20thoughtful%20composition&width=800&height=600&seq=cat-tips-04&orientation=landscape'
  },
  {
    id: 'community',
    name: '社群动态',
    slug: 'community',
    description: '同人动画社群最新资讯、展会信息与线上活动一手掌握。',
    icon: 'ri-group-line',
    image: 'https://readdy.ai/api/search-image?query=Collaborative%20creative%20workspace%20with%20multiple%20artists%20working%20together%20warm%20atmospheric%20lighting%20community%20gathering%20vibe%20soft%20beige%20and%20golden%20tones%20artistic%20illustration%20style%20friendly%20and%20welcoming%20atmosphere%20modern%20loft%20setting&width=800&height=600&seq=cat-community-05&orientation=landscape'
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});